<template>
  <div class="content_container">
    <div class="query">
      <span class="title">小记者查询</span>
      <van-field required v-model="mobile" placeholder="请输入监护人手机号码查询" />
      <div style="margin: 20px 0;text-align: center;">
        <van-button style="width: 20%;margin: auto;" round block type="primary" size="small" @click="onQuery">
          查询
        </van-button>
      </div>
    </div>
    <div class="container">
      <van-row style="border-bottom: 2px solid #eee;padding: 20px;font-weight: bold;">
        <van-col span="4">姓名</van-col>
        <van-col span="16" style="text-align: center;">手机号</van-col>
        <van-col span="4"></van-col>
      </van-row>
      <van-row v-for="(item, index) in list" :key="index" style="border-bottom: 2px solid #eee;padding: 20px;">
        <van-col span="4">{{ item.name }}</van-col>
        <van-col span="16" style="text-align: center;">{{ item.mobile }}</van-col>
        <van-col span="4" style="text-align: right;color: #08f;" @click="toDetail(item)">详情</van-col>
      </van-row>
    </div>
    <van-popup v-model:show="show" style="width: 390px; height: 710px; border-radius: 0 0 20px 20px; "
      position="center">
      <img v-if="vipDataURL" :src="vipDataURL" alt="" style="width: 100%; object-fit: cover;">
      <div v-else ref="vipImg" class="vipImg">
        <img :src="vip.vipImg" alt="" style="width: 100%; object-fit: cover; z-index: -1;
    position: absolute;" />
        <div class="top">
          <!-- <img src="../../../../public/static/images/activity/little-reporter/v2_szfdnj.png" alt="" /> -->
        </div>
        <div class="title">光明小记者会员</div>
        <div class="img">
          <img v-if="vip.authorPhoto" :src="vip.authorPhoto" />
          <img v-else src="../../../../public/static/images/activity/little-reporter/logo.png" />
        </div>
        <van-row class="info" style="margin-top: 20px;">
          <van-col span="8" class="label">姓&nbsp;&nbsp;&nbsp;名:</van-col>
          <van-col span="16" class="value">{{ vip.name }}</van-col>
        </van-row>
        <van-row class="info">
          <van-col span="8" class="label">学&nbsp;&nbsp;&nbsp;校:</van-col>
          <van-col span="16" class="value">{{ vip.school }}</van-col>
        </van-row>
        <van-row class="info">
          <van-col span="8" class="label">编&nbsp;&nbsp;&nbsp;号:</van-col>
          <van-col span="16" class="value">{{ vip.son }}</van-col>
        </van-row>
        <van-row class="info">
          <van-col span="8" class="label">有效期:</van-col>
          <van-col span="16" class="value">{{ vip.lifespan }}</van-col>
        </van-row>
      </div>
      <div class="download" @click="htmlDomDownload">下载证件</div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Notify } from "vant"
import api_activity from "@/assets/api/api_activity"
import { AuthMixin } from "@/assets/utils/mixin"
import html2canvas from "html2canvas"
import dayjs from "dayjs";

// eslint-disable-next-line no-undef

export default {
  // "最美红色故事发声人"视频、征文报名
  mixins: [AuthMixin],
  name: "wxcarnivalReporterApplyQuery",
  data() {
    return {
      type: 0,
      mobile: '',
      show: false,
      vip: {},
      list: [],
      vipImgList: [],
      vipDataURL: '',
    }
  },
  mounted() {
    this.getVIPIMG()
  },
  methods: {
    async toDetail(item) {
      let vipImg = 'https://wxfactory.zhmobi.com/educator/cover/202598/7a6c928a-6c62-4a9a-b644-1f3992af080f.png'
      // 链接域名替换weixinfactory.oss-cn-hangzhou.aliyuncs.com
      for (const i of this.vipImgList) {
        if (i.name === item.vipType) {
          vipImg = i.url
        }
      }
      vipImg = await this.getImageAsBase64(vipImg)
      if (item.authorPhoto) {
        item.authorPhoto = await this.getImageAsBase64(item.authorPhoto)
      }
      this.vip = { ...item, vipImg };
      this.show = true;
    },
    isPC() {
      const userAgentInfo = navigator.userAgent;
      // 移动设备关键词
      const mobileAgents = [
        'Android', 'iPhone', 'SymbianOS', 'Windows Phone',
        'iPad', 'iPod', 'BlackBerry', 'MQQBrowser', 'Opera Mini'
      ];

      // 检测是否包含移动设备关键词
      return !mobileAgents.some(agent => {
        return userAgentInfo.includes(agent);
      });
    },
    async getImageAsBase64(url) {
      if (this.isPC()) {
        return url;
      }
      const mimeType = 'image/png'
      return new Promise((resolve, reject) => {
        // 处理跨域
        const img = new Image();

        img.crossOrigin = 'anonymous';
        const useUrl = url;

        img.onload = function () {
          try {
            // 创建canvas元素
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // 设置canvas尺寸与图片一致
            canvas.width = this.naturalWidth;
            canvas.height = this.naturalHeight;

            // 绘制图片到canvas
            ctx.drawImage(this, 0, 0);

            // 转换为base64
            const base64 = canvas.toDataURL(mimeType);
            resolve(base64);
          } catch (error) {
            reject(new Error(`转换失败: ${error.message}`));
          }
        };

        img.onerror = function () {
          // 如果直接设置crossOrigin失败，尝试使用代理
          if (img.crossOrigin === 'anonymous') {
            img.crossOrigin = null;
            // 这里可以切换到代理方式重试
            // img.src = proxyUrl + url;
            resolve('');
            reject(new Error('图片加载失败，可能存在跨域问题，请确保服务器允许跨域访问或使用代理'));
          } else {
            reject(new Error('图片加载失败，请检查URL是否有效'));
          }
        };

        // 开始加载图片
        img.src = useUrl;

        // 处理超时
        setTimeout(() => {
          reject(new Error('图片加载超时'));
        }, 10000);
      });
    },
    getVIPIMG() {
      api_activity.getVIPIMG().then((res) => {
        if (res.errcode === 0) {
          this.vipImgList = res.data;
        }
      })
    },
    onQuery() {
      if (!this.mobile) {
        Notify({ type: "danger", message: "请输入监护人手机号" })
        return;
      }
      let params = {
        mobile: this.mobile,
        type: this.type
      }
      api_activity.getReporterNew(params).then((res) => {
        console.log(res.data);

        if (res.errcode === 0) {
          this.list = res.data.map(i => {
            return {
              ...i,
              ...JSON.parse(i.content),
              son: i.reporterNumber,
              lifespan: dayjs(i.startDate).format("YYYY.MM") + '-' + dayjs(i.endDate).format("YYYY.MM")
            }
          }) || [];
          if (this.list.length === 0) {
            Dialog.alert({
              title: "提示",
              message: "暂无查询结果",
            })
          }
        } else {
          Notify({ type: "danger", message: res.errmsg })
        }
      })
    },
    async htmlDomDownload() {
      const vipImg = this.$refs.vipImg;
      if (!vipImg) return;
      try {
        const canvas = await html2canvas(vipImg, {
          useCORS: true,
          scale: 2, // 放大倍数
        });
        const dataURL = canvas.toDataURL("image/png");
        this.vipDataURL = dataURL;
        const link = document.createElement("a");
        link.href = dataURL;
        link.download = "vip.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(dataURL);
        // 微信小程序客户端下载图片处理
        Dialog.alert({
          title: "提示",
          message: "图片已下载，微信手机客户端图片下载失请尝试长按图片保存或截图保存",
        })
      } catch (error) {
        console.error('生成图片失败:', error);
        Notify({ type: "danger", message: "生成图片失败，请重试" });
      }

    },
  },
  watch: {
    show: function (val) {
      if (val) {
        this.vipDataURL = '';
      }
    },
  }
}
</script>
<style lang="less" scoped>
.content_container {
  // @media (max-width: 800px) {
  //   min-width: 800px;
  //   transform: scale(0.7); /* 缩放为原来的80% */
  //   transform-origin: top left; /* 从左上角开始缩放 */
  // }
  min-height: 100vh;
  background-color: #fff;
  padding: 25px;

  .query {
    padding: 16px;
    background: #fff;

    .title {
      font-size: 25px;
      font-weight: bold;
      margin-bottom: 8px;
      display: block;
      color: #56b0fe;
    }
  }

  .container {
    margin-top: 50px;
    font-size: 25px;
  }

  .vipImg {
    width: 100%;
    height: 650px;

    .top {
      width: 50%;
      height: 80px;
      margin: auto;
      // background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0 0 15px 15px;

      img {
        width: 80%;
        margin-top: 20px;
      }
    }

    .title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #fff;
      margin: 30px;
    }

    .img {
      width: 150px;
      height: 200px;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 100%;
        width: auto;
      }
    }

    .info {
      font-size: 20px;
      padding: 5px 20px;
      color: #fff;
      margin-top: 10px;

      .label {
        text-align: right;
        font-weight: bold;
      }

      .value {
        padding-left: 20px;
        text-align: left;
      }

    }
  }

  .download {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    border-radius: 5px;
    font-size: 20px;
  }
}
</style>

<style>
.van-tabs__nav--card {
  margin: 0 !important;
}

.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #56b0fe;
}
</style>
